const _ = require('lodash')

export default {
    id: 'K',
    name: 'Actions',
    entities: _.concat(
        [
            require('./keenpointActions/configuration/sectorOfActivity').entity,
            require('./keenpointActions/configuration/function').entity,
            require('./keenpointActions/configuration/actionType').entity,
            require('./keenpointActions/configuration/workItemType').entity,
            require('./keenpointActions/referential/group').entity,
            require('./keenpointActions/referential/company').entity,
            require('./keenpointActions/referential/contact').entity,
            require('./keenpointActions/referential/groupAndCompany').entity,
            require('./keenpointActions/catalog/product').entity,
            require('./keenpointActions/catalog/part').entity,
            require('./keenpointActions/catalog/deployment').entity,
            require('./keenpointActions/sales/opportunity').entity,
            require('./keenpointActions/work/workItem').entity,
            require('./keenpointActions/work/action').entity,
        ],
        require('./keenpointActions/staticEntities').entities,
        require('./keenpointActions/entitiesActivities').entities,
        [
            require('./keenpointActions/dashboard').entity,
        ]
    ),
    description: '',
    modules:
        _.concat(
            [
                require('./keenpointActions/configuration/sectorOfActivity').module_,
                require('./keenpointActions/configuration/function').module_,
                require('./keenpointActions/configuration/actionType').module_,
                require('./keenpointActions/configuration/workItemType').module_,
                require('./keenpointActions/referential/group').module_,
                require('./keenpointActions/referential/company').module_,
                require('./keenpointActions/referential/contact').module_,
                require('./keenpointActions/catalog/product').module_,
                require('./keenpointActions/catalog/part').module_,
                require('./keenpointActions/catalog/deployment').module_,
                require('./keenpointActions/sales/opportunity').module_,
                require('./keenpointActions/work/workItem').module_,
                require('./keenpointActions/work/action').module_,
            ],
            require('./keenpointActions/modulesActivities').modules
        ),

}
